import LEPreviewV2 from "./LEPreviewV2";
export default LEPreviewV2;
